import React, { useEffect, useState } from "react";
import { ScrollText, Loader2, User, Building2, Flag, LogIn, Trash2, Edit3 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { owner } from "@/lib/owner-api";
import { formatDateTime } from "@/lib/format";

const actionIcons = {
  "owner.login": LogIn,
  "merchant.update": Edit3,
  "merchant.suspend": Building2,
  "merchant.delete": Trash2,
  "merchant.impersonate": User,
  "flag.update": Flag,
};

const actionColor = (a) => {
  if (a.includes("delete")) return "text-red-400 bg-red-900/30 border-red-800";
  if (a.includes("update") || a.includes("impersonate")) return "text-amber-400 bg-amber-900/30 border-amber-800";
  return "text-emerald-400 bg-emerald-900/30 border-emerald-800";
};

export default function OwnerAudit() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    owner.auditLogs(200).then(setLogs).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white">Audit Log</h1>
        <p className="text-sm text-gray-500 mt-1">Semua aksi Super Owner & platform admin tercatat di sini.</p>
      </div>

      <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden">
        {loading ? <div className="p-16 flex justify-center"><Loader2 className="animate-spin text-emerald-400" /></div>
          : logs.length === 0 ? (
            <div className="py-16 text-center">
              <ScrollText className="mx-auto text-gray-700" size={56} />
              <h3 className="mt-4 font-heading text-lg font-semibold text-white">Belum ada aktivitas</h3>
              <p className="mt-1 text-sm text-gray-500">Semua aksi admin akan muncul di sini secara real-time.</p>
            </div>
          ) : (
            <div className="divide-y divide-gray-800">
              {logs.map((l) => {
                const Icon = actionIcons[l.action] || ScrollText;
                return (
                  <div key={l.id} className="p-4 hover:bg-gray-800/40" data-testid={`log-${l.id}`}>
                    <div className="flex items-start gap-3">
                      <div className={`w-9 h-9 rounded-lg border flex items-center justify-center ${actionColor(l.action)}`}>
                        <Icon size={16} />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="font-semibold text-white">{l.actor_name}</span>
                          <Badge className="bg-gray-800 text-gray-400 border border-gray-700 text-[10px] capitalize">{l.actor_role.replace(/_/g, " ")}</Badge>
                          <span className="text-gray-500 text-sm">→</span>
                          <code className="text-xs text-emerald-400 bg-emerald-900/20 border border-emerald-900/40 rounded px-1.5 py-0.5">{l.action}</code>
                          {l.target_name && (
                            <>
                              <span className="text-gray-500 text-sm">·</span>
                              <span className="text-gray-300 text-sm">{l.target_name}</span>
                            </>
                          )}
                        </div>
                        {Object.keys(l.metadata || {}).length > 0 && (
                          <div className="mt-1 text-xs text-gray-500 font-mono">{JSON.stringify(l.metadata)}</div>
                        )}
                        <div className="mt-1 text-[10px] text-gray-600">{formatDateTime(l.created_at)}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
      </div>
    </div>
  );
}
